import ActionButton from "components/atoms/ActionButton";
import Button from "components/atoms/Button";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import React, { useEffect, useState } from "react";
import { PlusCircle, Trash, Trash2 } from "react-feather";
import Wilayah from "services/Wilayah";
import { PageMode, Source } from "utils/constant";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import KelambuDistribution from "services/KelambuDistribution";
import { toast } from "react-toastify";
import { errorToastNotif } from "utils/common";

const WilayahService = new Wilayah();
const KelambuDistributionService = new KelambuDistribution();

const Form = ({ changePageMode, item, pageMode }) => {
  const [errors, setErrors] = useState({});
  const [wilayah, setWilayah] = useState({
    provinces: [],
    districts: [],
    subdistricts: [],
    urbanvillages: [],
  });

  const [formPayload, setFormPayload] = useState({
    year: "",
    province_id: "",
    district_id: "",
    subdistrict_id: "",
    urbanvillage_id: "",
    target_population: "",
    total_mass_mosquito_nets: "",
    mass_focus_mosquito_nets: "",
  });

  const [kelambuPerDesa, setKelambuPerDesa] = useState([]);

  const handleCancel = () => {
    changePageMode("view");
  };

  const handleAddDesa = () => {
    setKelambuPerDesa([
      ...kelambuPerDesa,
      {
        id: uuidv4(),
        urbanvillage_id: "",
        target_population: "",
        total_mass_mosquito_nets: "",
        mass_focus_mosquito_nets: "",
      },
    ]);
  };

  const handleDeleteDesa = (id) => {
    setKelambuPerDesa(kelambuPerDesa.filter((desa) => desa.id !== id));
  };

  const handleDesaDataChange = (id, field, value) => {
    setKelambuPerDesa(
      kelambuPerDesa.map((desa) =>
        desa.id === id ? { ...desa, [field]: value } : desa
      )
    );
  };

  const validateForm = () => {
    let newErrors = {};
    // Common required fields
    if (!formPayload.year) newErrors.year = "Tahun wajib diisi";
    if (!formPayload.province_id)
      newErrors.province_id = "Provinsi wajib diisi";
    if (!formPayload.district_id)
      newErrors.district_id = "Kota/Kabupaten wajib diisi";
    if (!formPayload.subdistrict_id)
      newErrors.subdistrict_id = "Kecamatan wajib diisi";

    if (pageMode === PageMode.edit) {
      if (!formPayload.urbanvillage_id)
        newErrors.urbanvillage_id = "Desa/Kelurahan wajib diisi";
      if (!formPayload.target_population)
        newErrors.target_population = "Jumlah Penduduk Sasaran wajib diisi";
      if (!formPayload.mass_focus_mosquito_nets)
        newErrors.mass_focus_mosquito_nets = "Kelambu Massal Fokus wajib diisi";
    }

    if (pageMode === PageMode.add) {
      if (kelambuPerDesa.length === 0)
        newErrors.kelambuPerDesa = "Minimal 1 desa harus ditambahkan";
      kelambuPerDesa.forEach((desa, idx) => {
        if (!desa.urbanvillage_id)
          newErrors[`desa_${idx}_urbanvillage_id`] = `Desa pada baris ${idx + 1
            } wajib dipilih`;
        if (!desa.target_population)
          newErrors[
            `desa_${idx}_target_population`
          ] = `Jumlah penduduk sasaran pada baris ${idx + 1} wajib diisi`;
        if (!desa.total_mass_mosquito_nets)
          newErrors[
            `desa_${idx}_total_mass_mosquito_nets`
          ] = `Total Kelambu Massal pada baris ${idx + 1} wajib diisi`;
        if (!desa.mass_focus_mosquito_nets)
          newErrors[
            `desa_${idx}_mass_focus_mosquito_nets`
          ] = `Kelambu Massal Fokus pada baris ${idx + 1} wajib diisi`;
      });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Mohon lengkapi data yang wajib diisi", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "light",
      });
      return;
    }
    if (pageMode === PageMode.add) {
      const formattedPayload = kelambuPerDesa?.map((item) => {
        return {
          year: formPayload.year,
          province_id: formPayload.province_id,
          district_id: formPayload.district_id,
          subdistrict_id: formPayload.subdistrict_id,
          urbanvillage_id: item.urbanvillage_id,
          target_population: item.target_population,
          total_mass_mosquito_nets: item.total_mass_mosquito_nets,
          mass_focus_mosquito_nets: item.mass_focus_mosquito_nets,
        };
      });

      formattedPayload.forEach(async (item) => {
        try {
          await KelambuDistributionService.add(item)
            .then((res) => {
              toast.success("Data Kelambu Nasional Berhasil Ditambahkan", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "light",
              });
              changePageMode(PageMode.view);
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
        } catch (error) {
          console.log(error);
        }
      });
    } else if (pageMode === PageMode.edit) {
      try {
        await KelambuDistributionService.update(formPayload, item.id)
          .then((res) => {
            toast.success("Data Kelambu Nasional Berhasil Diubah", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              theme: "light",
            });
            changePageMode(PageMode.view);
          })
          .catch((err) => {
            console.log(err);
            errorToastNotif(err);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      setFormPayload({
        year: item.year,
        province_id: item.province_id,
        district_id: item.district_id,
        subdistrict_id: item.subdistrict_id,
        urbanvillage_id: item.urbanvillage_id,
        target_population: item.target_population,
        total_mass_mosquito_nets: item.total_mass_mosquito_nets,
        mass_focus_mosquito_nets: item.mass_focus_mosquito_nets,
      });
    }
  }, [pageMode, item]);

  useEffect(() => {
    fetchProvincies();
  }, []);

  useEffect(() => {
    if (formPayload.province_id) {
      fetchDistrictsByProvince(formPayload.province_id);
    } else {
      setWilayah((prevState) => ({
        ...prevState,
        districts: [],
      }));
    }
  }, [formPayload.province_id]);

  useEffect(() => {
    if (formPayload.district_id) {
      fetchSubdistrictsByDistrict(formPayload.district_id);
    } else {
      setWilayah((prevState) => ({
        ...prevState,
        subdistricts: [],
      }));
    }
  }, [formPayload.district_id]);

  useEffect(() => {
    if (formPayload.subdistrict_id) {
      fetchUrbanvillagesBySubdistrict(formPayload.subdistrict_id);
    } else {
      setWilayah((prevState) => ({
        ...prevState,
        urbanvillages: [],
      }));
    }
  }, [formPayload.subdistrict_id]);

  const fetchProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });

      setWilayah((prevState) => ({
        ...prevState,
        provinces: response.province?.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictsByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId?.split("|")[0],
      });

      setWilayah((prevState) => ({
        ...prevState,
        districts: response.district?.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSubdistrictsByDistrict = async (districtId) => {
    try {
      const response = await WilayahService.getAll(Source.SUBDISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId?.split("|")[0],
      });

      setWilayah((prevState) => ({
        ...prevState,
        subdistricts: response.subdistrict?.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUrbanvillagesBySubdistrict = async (subdistrictId) => {
    try {
      const response = await WilayahService.getAll(Source.URBANVILLAGE, {
        page: 1,
        limit: 9999,
        searchBy: "subdistrict_id",
        searchValue: subdistrictId?.split("|")[0],
      });

      setWilayah((prevState) => ({
        ...prevState,
        urbanvillages: response.urbanvillage?.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <h1>Tambah Data Dasar Kelambu</h1>

      <div
        style={{
          marginTop: "24px",
          marginBottom: "24px",
        }}
      >
        {/* Error global */}
        {errors.kelambuPerDesa && (
          <div style={{ color: "red", marginBottom: 8 }}>
            {errors.kelambuPerDesa}
          </div>
        )}
        {/* Baris 1: Tahun & Provinsi */}
        <div className="row mb-4">
          <div className="col-md-6">
            <InputDate
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                setFormPayload({ ...formPayload, year: selectedYear });
              }}
              label={"Tahun"}
              placeholder={"Pilih Tahun"}
              dateFormat={"YYYY"}
              value={formPayload.year}
              error={errors.year}
              errorMessage={errors.year}
            />
          </div>
          <div className="col-md-6">
            <InputSelect
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                setFormPayload({ ...formPayload, province_id: selectedValue });
              }}
              label={"Provinsi"}
              placeholder={"Pilih Provinsi"}
              data={wilayah.provinces}
              value={wilayah.provinces?.find(
                (item) => item.value === formPayload.province_id
              )}
              error={errors.province_id}
              errorMessage={errors.province_id}
            />
          </div>
        </div>

        {/* Baris 2: Kota/Kabupaten & Kecamatan */}
        <div className="row mb-4">
          <div className="col-md-6">
            <InputSelect
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                setFormPayload({ ...formPayload, district_id: selectedValue });
              }}
              label={"Kota/Kabupaten"}
              placeholder={"Pilih Kota/Kabupaten"}
              data={wilayah.districts}
              value={wilayah.districts?.find(
                (item) => item.value === formPayload.district_id
              )}
              error={errors.district_id}
              errorMessage={errors.district_id}
            />
          </div>
          <div className="col-md-6">
            <InputSelect
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                setFormPayload({ ...formPayload, subdistrict_id: selectedValue });
              }}
              label={"Kecamatan"}
              placeholder={"Pilih Kecamatan"}
              data={wilayah.subdistricts}
              value={wilayah.subdistricts?.find(
                (item) => item.value === formPayload.subdistrict_id
              )}
              error={errors.subdistrict_id}
              errorMessage={errors.subdistrict_id}
            />
          </div>
        </div>

        {pageMode === PageMode.edit && (
          <div>
            <InputSelect
              onChange={(e) => {
                const selectedValue = e ? e.value : "";
                setFormPayload({
                  ...formPayload,
                  urbanvillage_id: selectedValue,
                });
              }}
              label={"Desa/Kelurahan"}
              placeholder={"Pilih Desa/Kelurahan"}
              data={wilayah.urbanvillages}
              value={wilayah.urbanvillages?.find(
                (item) => item.value === formPayload.urbanvillage_id
              )}
              error={errors.urbanvillage_id}
              errorMessage={errors.urbanvillage_id}
            />

            <InputField
              label={"Jumlah Penduduk Sasaran"}
              placeholder={"Masukkan Jumlah Penduduk Sasaran"}
              value={formPayload.target_population}
              onChange={(e) => {
                setFormPayload({
                  ...formPayload,
                  target_population: e.target.value,
                });
              }}
              type={"number"}
              error={errors.target_population}
              errorMessage={errors.target_population}
            />

            <InputField
              label={"Total Kelambu Massal"}
              placeholder={"Masukkan Total Kelambu Massal"}
              value={formPayload.total_mass_mosquito_nets}
              onChange={(e) => {
                setFormPayload({
                  ...formPayload,
                  total_mass_mosquito_nets: e.target.value,
                });
              }}
              type={"number"}
              error={errors.total_mass_mosquito_nets}
              errorMessage={errors.total_mass_mosquito_nets}
            />

            <InputField
              label={"Kelambu Massal Fokus"}
              placeholder={"Masukkan Kelambu Massal Fokus"}
              value={formPayload.mass_focus_mosquito_nets}
              onChange={(e) => {
                setFormPayload({
                  ...formPayload,
                  mass_focus_mosquito_nets: e.target.value,
                });
              }}
              type={"number"}
              error={errors.mass_focus_mosquito_nets}
              errorMessage={errors.mass_focus_mosquito_nets}
            />
          </div>
        )}
      </div>

      {/* Bagian 2: Data Kelambu per Desa (tampilkan hanya di mode create) */}
      {pageMode === PageMode.add && (
        <>
          <h2 style={{ marginTop: "2px", marginBottom: "16px" }}>
            Data Kelambu per Desa
          </h2>

          {kelambuPerDesa.length === 0 && (
            <p style={{ fontStyle: "italic", color: "#666" }}>
              Belum ada data desa ditambahkan. Klik Tambah Desa untuk memulai.
            </p>
          )}

          <div className="table-responsive kelambu-table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th width="35%">Kelurahan/Desa</th>
                  <th>Jumlah Penduduk Sasaran</th>
                  <th>Kelambu Massal</th>
                  <th>Kelambu Massal Fokus</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {kelambuPerDesa.map((desa, idx) => {
                  const selectedVillageIds = kelambuPerDesa
                    .filter((d) => d.id !== desa.id && d.urbanvillage_id)
                    .map((d) => d.urbanvillage_id);

                  const availableVillages = wilayah.urbanvillages?.filter(
                    (village) => !selectedVillageIds.includes(village.value)
                  );

                  return (
                    <tr key={desa.id}>
                      <td style={{ overflow: "visible" }}>
                        <InputSelect
                          onChange={(e) => {
                            const selectedValue = e ? e.value : "";
                            handleDesaDataChange(
                              desa.id,
                              "urbanvillage_id",
                              selectedValue
                            );
                          }}
                          placeholder={"Pilih Desa"}
                          data={availableVillages}
                          value={wilayah.urbanvillages?.find(
                            (village) =>
                              village.value === desa.urbanvillage_id
                          )}
                          name={desa.id}
                        />
                        {errors[`desa_${idx}_urbanvillage_id`] && (
                          <div style={{ color: "red" }}>
                            {errors[`desa_${idx}_urbanvillage_id`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <InputField
                          type="number"
                          onChange={(e) =>
                            handleDesaDataChange(
                              desa.id,
                              "target_population",
                              e.target.value
                            )
                          }
                          placeholder={"Jumlah Penduduk Sasaran"}
                          value={desa.target_population}
                        />
                        {errors[`desa_${idx}_target_population`] && (
                          <div style={{ color: "red" }}>
                            {errors[`desa_${idx}_target_population`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <InputField
                          type="number"
                          onChange={(e) =>
                            handleDesaDataChange(
                              desa.id,
                              "mass_focus_mosquito_nets",
                              e.target.value
                            )
                          }
                          placeholder={"Jumlah Hasil Desk"}
                          value={desa.mass_focus_mosquito_nets}
                        />
                        {errors[`desa_${idx}_mass_focus_mosquito_nets`] && (
                          <div style={{ color: "red" }}>
                            {errors[`desa_${idx}_mass_focus_mosquito_nets`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <InputField
                          type="number"
                          onChange={(e) =>
                            handleDesaDataChange(
                              desa.id,
                              "total_mass_mosquito_nets",
                              e.target.value
                            )
                          }
                          placeholder={"Jumlah Hasil Desk"}
                          value={desa.total_mass_mosquito_nets}
                        />
                        {errors[`desa_${idx}_total_mass_mosquito_nets`] && (
                          <div style={{ color: "red" }}>
                            {errors[`desa_${idx}_total_mass_mosquito_nets`]}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <ActionButton
                          btnType={"delete"}
                          onClick={() => handleDeleteDesa(desa.id)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "16px",
            }}
          >
            <Button
              variant={"secondary"}
              size={"normal"}
              onClick={handleAddDesa}
              style={{
                border: "1px solid #D0F4F2",
              }}
            >
              <PlusCircle size={20} className="me-2" /> Tambah Desa
            </Button>
          </div>
        </>
      )}

      <div
        className="d-flex align-items-center gap-4 kelambu-form-actions"
        style={{ marginTop: "48px" }}
      >
        <Button variant={"primary"} size={"normal"} onClick={handleSubmit}>
          <PlusCircle size={20} className="me-2" />
          Simpan Data
        </Button>
        <Button variant={"secondary"} size="normal" onClick={handleCancel}>
          Batalkan
        </Button>
      </div>
    </>
  );
};

export default Form;
